module.exports = __webpack_public_path__ + "static/bg-form-f1b5dbfe644abae3ea83d7669b528db2.png";